module.exports = __webpack_public_path__ + "assets/b32.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b32.png
// module id = 619
// module chunks = 0